
import React from 'react';
import { Helmet } from 'react-helmet-async';
import ManagePartners from './ManagePartners';

const DomainExperts = () => {
  return (
    <>
      <Helmet>
        <title>Manage Domain Experts | Admin Portal</title>
      </Helmet>
      <ManagePartners type="Domain Expert" />
    </>
  );
};

export default DomainExperts;
